module.exports = __webpack_public_path__ + "img/white-cross.f0927c9b.svg";